import React from 'react';
import {Box, Button, DialogContent, Typography} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import {makeStyles} from "tss-react/mui";

export const SendHelpFormModal = () => {

	const {t} = useTranslation();

	const goToHome = () => {
		window.location.href = window.location.href.split(window.location.pathname)[0]
	};

	const useStyles = makeStyles()((theme) => {
		return {
			root: {
				textAlign: 'center',
				[theme.breakpoints.down('sm')]: {
					padding: '16px 24px!important',
				}
			},
			submitBtn: {
				borderRadius: '0!important',
				backgroundColor: '#FFEE00',
				color: '#000!important',
				fontSize: '12px!important',
				width: '65%!important',
				fontFamily: 'Jost, sans-serif!important',
				'&:hover': {
					backgroundColor: '#FFEE00',
				}
			}
		}
	});

	const { classes } = useStyles();

	return (
		<DialogContent className={classes.root}>
			<Box mb={3}>
				<Typography variant={'h5'} component={'h5'}>{t('grazie_per_averci_contattato')}</Typography>
				<Box mt={3} mb={3}>
					<Typography variant={'body1'} component={'p'}>{t('richiesta_inviata')}</Typography>
				</Box>
				<Button variant={'contained'} color={'primary'} onClick={() => goToHome()} className={classes.submitBtn}>{t('torna_alla_home')}</Button>
			</Box>
		</DialogContent>
	)
};
